import { TFunction } from 'i18next';
import {
  UserSuggest,
  AllUserResult,
  TopUserResult,
  Section,
  ErrorType,
  isErrorType,
} from '../../../../components/molecules/Form/components/ComboBox';
import { isNotNullOrUndefined, isNullOrUndefined } from '../../../../lib/typeGuards';

export default (t: TFunction) =>
  (userSuggestResponse?: UserSuggest | ErrorType): Section<TopUserResult | AllUserResult>[] => {
    if (isNullOrUndefined(userSuggestResponse) || isErrorType(userSuggestResponse)) {
      return [];
    }

    const topResults: TopUserResult[] = userSuggestResponse.topResults.map(r => ({
      ...r,
      type: 'topUserResult',
    }));
    const allResultsItem: AllUserResult | undefined =
      topResults.length > 0 && userSuggestResponse.allUrl
        ? {
            id: `allUserResults`,
            type: 'allUserResult',
            pageLink: {
              url: userSuggestResponse.allUrl.url,
              name: t(`user.resultsLabel`),
            },
          }
        : undefined;

    const combinedResults = [...topResults, allResultsItem].filter(isNotNullOrUndefined);
    return [
      {
        key: 'user',
        results: combinedResults,
        headline: t(`user.headline`) as string,
      },
    ];
  };
